export default __webpack_public_path__ + "static/media/iconSupermarket.ab615b91.svg";